/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { A as ActionSheet, d as defineCustomElement$1 } from './action-sheet.js';

const IonActionSheet = ActionSheet;
const defineCustomElement = defineCustomElement$1;

export { IonActionSheet, defineCustomElement };
